export const initialValuesLogin = {
	hash: '',
	key: ''
};
